<template>
  <div class="documentation">
    <Breadcumb title="Ajouter une catégorie" :breadcumb-data="breadcumbData"></Breadcumb>
    <b-card class="cardcontainer">
      <b-form @submit="addCategory">
        <b-form-group label="Nom en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Label" v-model="label_en" :state="errors['label_en'] ? 'invalid': ''"/>
          <div v-if="errors['label_en']" class="invalid-tooltip">{{ errors['label_en'][0] }}</div>
        </b-form-group>
        <b-form-group label="Nom en Français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Label français" v-model="label" :state="errors.label ? 'invalid': ''"/>
          <div v-if="errors['label']" class="invalid-tooltip">{{ errors['label'][0] }}</div>
        </b-form-group>
        <b-form-group label="Description en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-textarea placeholder="Description en anglais" :rows="3" v-model="description_en"/>
        </b-form-group>
        <b-form-group label="Description en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-textarea placeholder="Description en français" :rows="3" v-model="description"/>
        </b-form-group>
        <b-form-group label="Ordre d'affichage" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="number" placeholder="Ordre d'affichage" v-model="order" :state="errors.order ? 'invalid': ''"/>
          <div v-if="errors['order']" class="invalid-tooltip">{{ errors['order'][0] }}</div>
        </b-form-group>
        <b-form-group label="Cible" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-check-group plain v-model="user_types" :options="userTypeData"/>
          <div v-if="errors['user_types']" class="invalid-tooltip">{{ errors['user_types'][0] }}</div>
        </b-form-group>
        <b-form-row>
          <div class="col-md-10 ml-md-auto">
            <b-btn type="submit" variant="primary">Ajouter la catégorie</b-btn>
          </div>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>
  import { ADMIN_ADD_CATEGORY_REQUEST } from '../../_store/administration/document/actiontypes';
  import { ADMIN_GET_USERTYPES_REQUEST} from '../../_store/administration/user/actiontypes'
  import { mapState } from 'vuex';
  import Breadcumb from '../../components/breadcumb';

  export default {
    name: 'adminCategoryAdd',
    mounted() {
      this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
        .then(response => {
          this.userTypeData = response.data.usertypes.map(userType => {
            return {
              value: userType.id,
              text: userType.label
            };
          });
        });
    },
    computed: mapState({ errors: state => state.admin_document.errors }),
    components: {Breadcumb, },
    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des documents pédagogiques', href: '/dashboard/administration/documentation/' },
          { text: 'Ajouter une catégorie', active: true },
        ],
        userTypeData: [],
        user_types: [],
        label_en: '',
        label: '',
        description_en: '',
        description: '',
        order: 0
      });
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      addCategory: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_ADD_CATEGORY_REQUEST, {
          label_en: this.label_en,
          label: this.label,
          description_en: this.description_en,
          description: this.description,
          order: this.order,
          user_types: this.user_types
        })
          .then(() => {
            this.$router.push('/dashboard/administration/documentation/');
          })
          .catch((error) => {
            console.log('error is ==');
            console.log(error);
          });
      }
    }
  };
</script>
